import { CfbApp } from './schedule-picker';
import { mapDictionaryToArray, rankSort } from '../shared/helpers';

(window as any).SchedulePicker = (window as any).SchedulePicker ?? {};
(window as any).SchedulePicker.App = { mapDictionaryToArray, RankSort: rankSort };

// Instantiate on DOMContentLoaded — mirrors the legacy $(document).ready pattern.
document.addEventListener('DOMContentLoaded', () => {
  const app = new CfbApp();
  // Expose instance methods used in KO view bindings
  (window as any).SchedulePicker.App.convertPrimeTimeToShortString = app.convertPrimeTimeToShortString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeToString = app.convertPrimeTimeToString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeAndDateToString = app.convertPrimeTimeAndDateToString.bind(app);

  // Expose for Razor view inline access and browser debugging
  (window as any).vm = app;
  (window as any).__pp_debug = (window as any).__pp_debug ?? {};
  (window as any).__pp_debug.cfbApp = app;
});
